// https://stackoverflow.com/questions/901115/how-can-i-get-query-string-values-in-javascript?noredirect=1&lq=1
export default function unserialize(qs) {
	var params = {};
	if (!qs) {
		return params;
	}
	if (qs.substr(0, 1) === '?') {
		qs = qs.substr(1);
	}

	qs.split("&").forEach(function (item) {
		var parts = item.split("="),
			key = parts[0],
			val = parts[1] && decodeURIComponent(parts[1]); // null-coalescing / short-circuit

		if ( /\[.*\]$/.test(key) ) {
			key = key.replace(/\[.*\]$/, '');
			if (!params[key]) {
				params[key] = [];
			}
			params[key].push(val);
		} else {
			params[key] = val;
		}
	});

	return params;
}
